"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getValidatedRedirectURL = function getValidatedRedirectURL(originalRedirectUrl) {
  if (typeof originalRedirectUrl !== 'string') {
    return '/';
  }

  var decodedUrl = decodeURIComponent(originalRedirectUrl).replace(/\s/g, '');
  var a = document.createElement('a');
  a.href = decodedUrl;
  var domainMatchPattern = /\.(angi|angieslist).com$/;

  if (a.origin && a.origin.match(domainMatchPattern)) {
    return a.href;
  } else if (location.origin !== a.origin) {
    return '/';
  }

  return a.href;
};

var _default = getValidatedRedirectURL;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/validateRedirect/index.js
// module id = 1905
// module chunks = 25